import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
export default class Field_access_rules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      isSubmitting: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.field_access_rules_Id,
          sortable: true,
          cell: (row) => <span>{row.field_access_rules_Id}</span>,
        },
        {
          name: "Role ID",
          selector: (row, i) => row.roleId,
          sortable: true,
          cell: (row) => <span>{row.roleId}</span>,
        },
        {
          name: "Resource",
          selector: (row, i) => row.resource,
          sortable: true,
          cell: (row) => <span>{row.resource}</span>,
        },
        {
          name: "Field Name",
          selector: (row, i) => row.fieldName,
          sortable: true,
          cell: (row) => <span>{row.fieldName}</span>,
        },
        {
          name: "Can View",
          selector: (row, i) => row.canView,
          sortable: true,
          cell: (row) => <span>{row.canView}</span>,
        },
        {
          name: "Can Edit",
          selector: (row, i) => row.canEdit,
          sortable: true,
          cell: (row) => <span>{row.canEdit}</span>,
        },
        {
          name: "Mask Type",
          selector: (row, i) => row.maskType,
          sortable: true,
          cell: (row) => <span>{row.maskType}</span>,
        },
        {
          name: "Mask Pattern",
          selector: (row, i) => row.maskPattern,
          sortable: true,
          cell: (row) => <span>{row.maskPattern}</span>,
        },
        {
          name: "Is Active",
          selector: (row, i) => row.isActive,
          sortable: true,
          cell: (row) => <span>{row.isActive}</span>,
        },

        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Field_access_ruleseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
      field_access_rules_Id: "",
      roleId: "",
      resource: "",
      fieldName: "",
      canView: "",
      canEdit: "",
      maskType: "",
      maskPattern: "",
      isActive: 1,
      roles: [],
      tables: [],
      columns: [],
      datatablefieldaccess:[],
      datatablefieldone:[],
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName,
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName,
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName,
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "roleId",
        inputType: "Number",
        displayName: "Role ID",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "resource",
        inputType: "Text",
        displayName: "Resource",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "fieldName",
        inputType: "Text",
        displayName: "Field Name",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "canView",
        inputType: "Number",
        displayName: "Can View",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "canEdit",
        inputType: "Number",
        displayName: "Can Edit",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "maskType",
        inputType: "Text",
        displayName: "Mask Type",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "maskPattern",
        inputType: "Text",
        displayName: "Mask Pattern",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "isActive",
        inputType: "Number",
        displayName: "Is Active",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      roleId: "",
      resource: "",
      fieldName: "",
      canView: "",
      canEdit: "",
      maskType: "",
      maskPattern: "",
      isActive: 1,
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      roleId: "",
      resource: "",
      fieldName: "",
      canView: "",
      canEdit: "",
      maskType: "",
      maskPattern: "",
      isActive: 1,
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Field_access_ruleseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      field_access_rules_Id: row.field_access_rules_Id,
      roleId: row.roleId,
      resource: row.resource,
      fieldName: row.fieldName,
      canView: row.canView,
      canEdit: row.canEdit,
      maskType: row.maskType,
      maskPattern: row.maskPattern,
      isActive: row.isActive,

      errors: {},
      touched: {},
    });
  };

  Field_access_rulesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Field_access_rules/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  DatatablefieldaccessmasterfetchHandler = () => {
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      
      fetch(configData.api_url +'C_Datatablefieldaccessmaster/list', {
        method: 'POST', 
        mode: 'cors', 
        body: formData
      })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ datatablefieldaccess: data.list,datatablefieldone: data.list, });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
    }
    RolesfetchHandler = () => {
        var formData = new FormData();
        formData.append("sId", this.state.sId);
        formData.append("uId", this.state.uId);
        fetch(configData.api_url + "roles/all", {
          // Enter your IP address here
          method: "POST",
          //headers :{ 'Content-Type' : 'application/json'},
          mode: "cors",
          body: formData, // body data type must match "Content-Type" header
        })
          .then((response) => response.json())
          .then((data) => {
            window.showToast(data.message, data.status);
            if (data.status === "success") {
              this.setState({ roles: data.list });
            }
          });
      };
     getTables = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "/masters/gettables", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({ tables: data.tables });
          this.showToast(data.message, data.status);
        } else {
          this.showToast(data.message || "Failed to load tables", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching tables:", error);
        this.showToast(
          "Failed to load tables. Please check your connection.",
          "error",
        );
      });
  };

  getColumns = (tableName) => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);

    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({ columns: data.columns });
          this.showToast(data.message, data.status);
        } else {
          this.showToast(data.message || "Failed to load columns", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching columns:", error);
        this.showToast(
          "Failed to load columns. Please check your connection.",
          "error",
        );
      });
  };
  Field_access_rulessubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      this.setState({ isSubmitting: false });
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("roleId", this.state.roleId);
    formData.append("resource", this.state.resource);
    formData.append("fieldName", this.state.fieldName);
    formData.append("canView", this.state.canView);
    formData.append("canEdit", this.state.canEdit);
    formData.append("maskType", this.state.maskType);
    formData.append("maskPattern", this.state.maskPattern);
    formData.append("isActive", this.state.isActive);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Field_access_rules/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Field_access_rulesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            roleId: "",
            resource: "",
            fieldName: "",
            canView: "",
            canEdit: "",
            maskType: "",
            maskPattern: "",
            isActive: "",
          });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });})
      .finally(() => this.setState({ isSubmitting: false }));
  };

  Field_access_rulesupdateHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("field_access_rules_Id", this.state.field_access_rules_Id);
    formData.append("roleId", this.state.roleId);
    formData.append("resource", this.state.resource);
    formData.append("fieldName", this.state.fieldName);
    formData.append("canView", this.state.canView);
    formData.append("canEdit", this.state.canEdit);
    formData.append("maskType", this.state.maskType);
    formData.append("maskPattern", this.state.maskPattern);
    formData.append("isActive", this.state.isActive);

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Field_access_rules/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Field_access_rulesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });})
      .finally(() => this.setState({ isSubmitting: false }));
  };

  componentDidMount() {
    this.Field_access_rulesfetchHandler();
    this.DatatablefieldaccessmasterfetchHandler();
    this.getTables();
    this.RolesfetchHandler();
  }

  handleroleIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ roleId: fieldValue });
  };
  handleresourceChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    //this.setState({ resource: fieldValue });
    this.setState({ resource: fieldValue, fieldName: "", columns: [] }, () => {
    if (fieldValue) {
      this.getColumns(fieldValue);
    }
  });
  };
  handlefieldNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ fieldName: fieldValue });
  };
  handlecanViewChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ canView: fieldValue });
  };
  handlecanEditChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ canEdit: fieldValue });
  };
  handlemaskTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maskType: fieldValue });
  };
  handlemaskPatternChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maskPattern: fieldValue });
  };
  handleisActiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ isActive: fieldValue });
  };

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(
        `Are you sure you want to delete this field_access_rules?`,
      )
    ) {
      return;
    }

    var formData = new FormData();
    formData.append("field_access_rules_Id", row.field_access_rules_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Field_access_rules/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Field_access_rulesfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Field Access Rules
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      {/* <Button
                variant="primary" style={{ float: "right", marginBottom: "10px" }}
                className="bi bi-plus "
                onClick={this.handleOffcanvasShow}
              >
              New
              </Button> */}

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Field_access_rules
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Role ID
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={this.handleroleIdChange}
                                        className="form-select"
                                        name="roleId"
                                        value={this.state.roleId}
                                        required="required"
                                        placeholder="Enter Tasks Table"
                                      >
                                        <option defaultValue>
                                          Select
                                        </option>
                                        {this.state.roles.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.rId}
                                            >
                                              {api.rName}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.roleId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Resource
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        name="resource"
                                        value={this.state.resource}
                                        onChange={this.handleresourceChange}
                                      >
                                        <option value="">Select Table</option>
                                        {this.state.tables.map((api, index, idx) => (
                                          <option key={index} value={api}>
                                            {api}
                                          </option>
                                        ))}
                                      </Form.Control>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.resource}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Field Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        aria-label="Default select example"
                                        name="fieldName"
                                        value={this.state.fieldName}
                                        onChange={this.handlefieldNameChange}
                                      >
                                        <option value="">Column</option>
                                        {this.state.columns.map((api, index) => (
                                          <option
                                            key={index}
                                            value={api}
                                          >
                                            {api}
                                          </option>
                                        ))}
                                      </Form.Control>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.fieldName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Can View
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlecanViewChange}
                                        className="form-control"
                                        name="canView"
                                        value={this.state.canView}
                                        required="required"
                                        placeholder="Enter canView"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.canView}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Can Edit
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlecanEditChange}
                                        className="form-control"
                                        name="canEdit"
                                        value={this.state.canEdit}
                                        required="required"
                                        placeholder="Enter canEdit"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.canEdit}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Mask Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={this.handlemaskTypeChange}
                                        className="form-select"
                                        name="maskType"
                                        value={this.state.maskType}
                                        required="required"
                                        placeholder="Enter maskType"
                                      >
                                        <option defaultValue>
                                          Select
                                        </option>
                                        {this.state.datatablefieldaccess
                                          .filter((api) => api.maskType !== "" && api.maskType !== null && api.maskType !== undefined)
                                          .map((api, index) => (
                                            <option key={index} value={api.maskType}>
                                              {api.maskType}
                                            </option>
                                          ))
                                        }
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maskType}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Mask Pattern
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        onChange={this.handlemaskPatternChange}
                                        className="form-select"
                                        name="maskPattern"
                                        value={this.state.maskPattern}
                                        required="required"
                                        placeholder="Enter maskPattern"
                                      >
                                        <option defaultValue>
                                          Select
                                        </option>
                                        {this.state.datatablefieldone
                                          .filter((api) => api.maskPattern !== "" && api.maskPattern !== null && api.maskPattern !== undefined)
                                          .map((api, index) => (
                                            <option key={index} value={api.maskPattern}>
                                              {api.maskPattern}
                                            </option>
                                          ))
                                        }
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maskPattern}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Is Active
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleisActiveChange}
                                        className="form-control"
                                        name="isActive"
                                        value={this.state.isActive}
                                        required="required"
                                        placeholder="Enter isActive"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.isActive}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Field_access_rulessubmitHandler}
                                  disabled={
                                    this.state.isSubmitting ||
                                    !this.isFormValid()
                                  }
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  {this.state.isSubmitting ? (
                                    <>
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                      />
                                      Saving...
                                    </>
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Field_access_rules
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      ),
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Role ID
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                        onChange={this.handleroleIdChange}
                                        className="form-select"
                                        name="roleId"
                                        value={this.state.roleId}
                                        required="required"
                                        placeholder="Enter Tasks Table"
                                      >
                                        <option defaultValue>
                                          Select
                                        </option>
                                        {this.state.roles.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.rId}
                                            >
                                              {api.rName}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.roleId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Resource
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                        as="select"
                                        className="form-select"
                                        name="resource"
                                        value={this.state.resource}
                                        onChange={this.handleresourceChange}
                                      >
                                        <option value="">Select Table</option>
                                        {this.state.tables.map((api, index, idx) => (
                                          <option key={index} value={api}>
                                            {api}
                                          </option>
                                        ))}
                                      </Form.Control>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.resource}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Field Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                        as="select"
                                        className="form-select"
                                        aria-label="Default select example"
                                        name="fieldName"
                                        value={this.state.fieldName}
                                        onChange={this.handlefieldNameChange}
                                      >
                                        <option value="">Column</option>
                                        {this.state.columns.map((api, index) => (
                                          <option
                                            key={index}
                                            value={api}
                                          >
                                            {api}
                                          </option>
                                        ))}
                                      </Form.Control>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.fieldName}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Can View
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlecanViewChange}
                                          className="form-control"
                                          name="canView"
                                          value={this.state.canView}
                                          required="required"
                                          placeholder="Enter canView"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.canView}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Can Edit
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlecanEditChange}
                                          className="form-control"
                                          name="canEdit"
                                          value={this.state.canEdit}
                                          required="required"
                                          placeholder="Enter canEdit"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.canEdit}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Mask Type
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                        onChange={this.handlemaskTypeChange}
                                        className="form-select"
                                        name="maskType"
                                        value={this.state.maskType}
                                        required="required"
                                        placeholder="Enter maskType"
                                      >
                                        <option defaultValue>
                                          Select
                                        </option>
                                        {this.state.datatablefieldaccess
                                          .filter((api) => api.maskType !== "" && api.maskType !== null && api.maskType !== undefined)
                                          .map((api, index) => (
                                            <option key={index} value={api.maskType}>
                                              {api.maskType}
                                            </option>
                                          ))
                                        }
                                      </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.maskType}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Mask Pattern
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                        onChange={this.handlemaskPatternChange}
                                        className="form-select"
                                        name="maskPattern"
                                        value={this.state.maskPattern}
                                        required="required"
                                        placeholder="Enter maskPattern"
                                      >
                                        <option defaultValue>
                                          Select
                                        </option>
                                        {this.state.datatablefieldone
                                          .filter((api) => api.maskPattern !== "" && api.maskPattern !== null && api.maskPattern !== undefined)
                                          .map((api, index) => (
                                            <option key={index} value={api.maskPattern}>
                                              {api.maskPattern}
                                            </option>
                                          ))
                                        }
                                      </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.maskPattern}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Is Active
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleisActiveChange}
                                          className="form-control"
                                          name="isActive"
                                          value={this.state.isActive}
                                          required="required"
                                          placeholder="Enter isActive"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.isActive}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.Field_access_rulesupdateHandler
                                    }
                                    disabled={
                                      this.state.isSubmitting ||
                                      !this.isFormValid()
                                    }
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    {this.state.isSubmitting ? (
                                      <>
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                          className="me-1"
                                        />
                                        Updating...
                                      </>
                                    ) : (
                                      "Update"
                                    )}
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[
                          100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                        ]}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
